import Tabby from 'tabbyjs/dist/js/tabby.min.js';

export default function initTabs() {
  const tabElements = document.querySelectorAll('[data-tabs]');

  if (tabElements.length == 0) return;

  tabElements.forEach(tabs => {
    let tabElement = tabs;
    tabs = new Tabby('[data-tabs]');
  })
}